<app-help  helpText="{{ 'helps.request-failed' | translate }}"></app-help>
